import ReportTitle from "./core/ReportTitle";
import ReportDescription from "./core/ReportDescription";
import { useReport } from "../../fetch/fetch.report";
import { EMPTY_REPORT } from "../../const/typeDefault/ReportDefault";
import ErrMessage from "../core/ErrMessage";
import { LOADING_CIRCLE } from "../core/loading/LoadingCircle";
import UserCompact from "../user/view/UserCompact";
import { Link } from "react-router-dom";
import { ROUTE_PRODUCT, ROUTE_PROFILE } from "../../const/routes";
import ItemListElem from "../item/core/ItemListElem.tsx";
import Authorized from "../core/auth/Authorized.tsx";
import ReportResponseForm from "./ReportResponseForm.tsx";
import { UserRole } from "../../types/User.ts";

const ReportCompact = ({ id }: { id: string }) => {
  const { report, isLoading, isError } = useReport(id, EMPTY_REPORT);

  if (isError) return <ErrMessage message={isError.message} />;
  if (isLoading) return LOADING_CIRCLE;

  return (
    <div className="card bg-base-100 shadow-md rounded-xl border border-base-200 w-full">
      <div className="card-body gap-3">
        {/* Titel + Beschreibung */}
        <div>
          <h2 className="card-title text-lg font-semibold">
            <ReportTitle id={id} />
          </h2>
          <p className="text-sm opacity-80">
            <ReportDescription id={id} />
          </p>
        </div>

        {/* User Info */}
        {report.userId && (
          <div className="pt-2 border-t border-base-200">
            <Link to={ROUTE_PROFILE(report.userId)}>
              <UserCompact userId={report.userId}>
                <p>{report.userId}</p>
              </UserCompact>
            </Link>
          </div>
        )}

        {/* Item Info */}
        {report.itemId && (
          <div className="pt-2 border-t border-base-200">
            <Link
              to={ROUTE_PRODUCT(report.itemId)}
              className="link link-hover text-sm"
            >
              <ItemListElem id={report.itemId} />
            </Link>
          </div>
        )}
        <Authorized role={UserRole.Moderator}>
          <ReportResponseForm reportId={id} />
        </Authorized>
      </div>
    </div>
  );
};

export default ReportCompact;
